import { request } from '../../../lib/request_cms';
/**
 * 租户自定义配置（pms 服务 Pms Tenant Config Controller）
 * 每个站点(tenantId)一条：自定义名称 tenantName、排序 sortOrder、显示/隐藏 displayStatus(0隐藏/1显示) 等
 */
// 根据产品组ID获取配置列表
export function getTenantConfigList(params) {
    return request({
        url: '{#npgw}/pms/tenant/config/list',
        method: 'get',
        params,
    });
}
// 根据租户ID获取配置详情
export function getTenantConfigDetail(params) {
    return request({
        url: '{#npgw}/pms/tenant/config/detail',
        method: 'get',
        params,
    });
}
// 批量保存配置。入参是配置数组：[{ id?, tenantId, tenantName, tenantIcon?, sortOrder, status, displayStatus, instanceCode, productGroupId }]
export function batchSaveTenantConfig(data) {
    return request({
        url: '{#npgw}/pms/tenant/config/batchSave',
        method: 'post',
        data,
    });
}

// ===== 站点列表统一叠加租户自定义配置：隐藏(displayStatus=0)的站点过滤掉，自定义名称写到 customName =====
// 网站状态页自己用 getTenantInfos 拿全量，不走这里；其余站点列表接口在 API 层统一处理，各处页面不用各自请求
let configCache = null; // { groupId, promise: Promise<{ [tenantId]: 配置 }> }
async function getConfigMap() {
    // 动态引入 store，避免与 store 模块里引用的 api 文件形成循环依赖
    const { default: store } = await import('@/store');
    const tenantJson = store.state.numberPortal && store.state.numberPortal.tenantJson;
    const groupId = tenantJson && tenantJson.productGroupId;
    if (!groupId) return {};
    if (!configCache || configCache.groupId !== groupId) {
        const promise = getTenantConfigList({ productGroupId: groupId }).then(list => {
            const map = {};
            (Array.isArray(list) ? list : []).forEach(c => (map[String(c.tenantId)] = c));
            return map;
        });
        configCache = { groupId, promise };
        promise.catch(() => {
            if (configCache && configCache.promise === promise) configCache = null; // 失败不缓存，下次重试
        });
    }
    return configCache.promise;
}
// 保存租户配置后调用，让下一次站点列表请求重新读取
export function clearTenantConfigCache() {
    configCache = null;
}
// 入参是站点列表接口的响应 { status, data: [...] }，返回同一个响应。读配置失败时原样返回，不影响正常使用
export async function filterHiddenTenants(res) {
    if (!res || !Array.isArray(res.data)) return res;
    try {
        const map = await getConfigMap();
        res.data = res.data
            .filter(t => !(map[String(t.id)] && map[String(t.id)].displayStatus === 0))
            .map(t => {
                const c = map[String(t.id)];
                return c && c.tenantName ? { ...t, customName: c.tenantName } : t;
            })
            // 按网站状态页保存的 sortOrder 升序；没有配置的排最后，保持原相对顺序（与网站状态页 applyConfigOrder 规则一致）
            .map((t, i) => {
                const c = map[String(t.id)];
                return { t, i, o: c && c.sortOrder != null ? c.sortOrder : null };
            })
            .sort((a, b) => (a.o === null) - (b.o === null) || a.o - b.o || a.i - b.i)
            .map(x => x.t);
    } catch (e) {}
    return res;
}
